import { Observable } from 'rxjs/Observable'
import { User } from '../../users/users.module'

export class Conversation {
  public id: string
  public hasStarted: boolean
  public lastText: string
  public receiverDeleted: boolean
  public receiverRead: boolean
  public senderDeleted: boolean
  public senderRead: boolean
  public timestamp: string
  public receiverUid: string
  public senderUid: string
  public isSender: boolean

  public otherUser$: Observable<User>

  get otherUserUid(): string {
    return (this.isSender) ? this.receiverUid : this.senderUid
  }

  get isReceiver(): boolean {
    return !this.isSender
  }

  get hasNewMessage(): boolean {
    return this.isSender && !this.senderRead || this.isReceiver && !this.receiverRead
  }

  get hasNewInvite(): boolean {
    return this.hasNewMessage && this.lastText === 'Come to my movies !'
  }

  get isDisabled(): boolean {
    return !this.hasStarted && this.isSender
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/chatroom/shared/conversation.model.ts